import { render, staticRenderFns } from "./damages.vue?vue&type=template&id=ddf74b0e&scoped=true"
import script from "./damages.vue?vue&type=script&lang=js"
export * from "./damages.vue?vue&type=script&lang=js"
import style0 from "./damages.vue?vue&type=style&index=0&id=ddf74b0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf74b0e",
  null
  
)

export default component.exports